import { Component, OnInit, Input } from '@angular/core';
import { ChartInputModel } from 'src/app/core/model/input/chart-input-model';
import * as pluginAnnotations from 'chartjs-plugin-annotation';

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss'],
})
export class LineChartComponent implements OnInit {
  private _input: ChartInputModel;
  @Input() set input(value: ChartInputModel) {
    this._input = value;
    this.prepareValues(this._input);
  }
  get input(): ChartInputModel {
    return this._input;
  }

  public lineChartOptions = {
    responsive: true,
    scales: {
      xAxes: [
        {
          id: 'x-axis-0',
          barThickness: 8,
          gridLines: {
            display: false,
            drawBorder: false,
          },
          ticks: {
            fontSize: 12,
            fontColor: 'black',
            fontFamily: 'Vazir',
          },
        },
      ],
      yAxes: [
        {
          id: 'y-axis-0',
          position: 'left',
          ticks: {
            beginAtZero: false,
            fontSize: 12,
            fontColor: '#6e6e6e',
            maxTicksLimit: 5,
            min: 40,
            max: 150,
            // stepSize: 10,
            fontFamily: 'Vazir',
            textAlign: 'left',
          },
          scaleLabel: {
            display: true,
            labelString: 'کیلوگرم',
            fontSize: 12,
            fontColor: '#6e6e6e',
            fontFamily: 'Vazir',
          },
          gridLines: {
            display: false,
            drawBorder: false,
          },
        },
      ],
    },
    annotation: {
      drawTime: 'beforeDatasetsDraw',
      annotations: [
        {
          type: 'line',
          mode: 'horizontal',
          scaleID: 'y-axis-0',
          value: 80,
          borderColor: '#cccccc',
          borderWidth: 0.7,
          // label: {
          //   enabled: true,
          //   fontColor: '#ffffff',
          //   content: 'ایده‌آل',
          //   backgroundColor: '#d9d9d9'
          // }
        },
      ],
    },
    legend: { display: false },
  };
  public lineChartLabels = ['', '', '', ''];
  public lineChartType = 'line';
  public lineChartPlugins = [pluginAnnotations];

  public lineChartColors = [
    {
      backgroundColor: '#ffffff',
      borderColor: '#443d99',
      pointBackgroundColor: '#443d99',
      pointBorderColor: '#443d99',
      pointHoverBackgroundColor: '#443d99',
      pointHoverBorderColor: '#443d99',
    },
  ];

  public lineChartData = [
    {
      data: [0, 0, 0, 0],
      tension: 0.0,
      borderWidth: 1,
    },
  ];

  constructor() {}

  ngOnInit() {}

  prepareValues(input: ChartInputModel) {
    if (input) {
      // console.log(input);

      this.lineChartOptions = {
        responsive: true,
        scales: {
          xAxes: [
            {
              id: 'x-axis-0',
              barThickness: 8,
              gridLines: {
                display: false,
                drawBorder: false,
              },
              ticks: {
                fontSize: 12,
                fontColor: 'black',
                fontFamily: 'Vazir',
              },
            },
          ],
          yAxes: [
            {
              id: 'y-axis-0',
              position: 'left',
              ticks: {
                beginAtZero: false,
                fontSize: 12,
                fontColor: '#6e6e6e',
                maxTicksLimit: 5,
                // stepSize: this.calculateStepValue(),
                min: this.calculateMinValue(),
                max: this.calculateMaxValue(),
                fontFamily: 'Vazir',
                textAlign: 'left',
              },
              scaleLabel: {
                display: true,
                labelString: 'کیلوگرم',
                fontSize: 12,
                fontColor: '#6e6e6e',
                fontFamily: 'Vazir',
              },
              gridLines: {
                display: false,
                drawBorder: false,
              },
            },
          ],
        },
        annotation: {
          drawTime: 'beforeDatasetsDraw',
          annotations: [
            {
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: input.ideal,
              borderColor: '#cccccc',
              borderWidth: 0.7,
              // label: {
              //   enabled: true,
              //   fontColor: '#ffffff',
              //   content: 'ایده‌آل',
              //   backgroundColor: '#d9d9d9'
              // }
            },
          ],
        },
        legend: { display: false },
      };

      this.lineChartLabels = input.labels;
      this.lineChartData[0].data = input.data;
    }
  }

  calculateMinValue(): number {
    const arrayMin = Math.min(...this.input.data);
    // const step = this.calculateStepValue();
    // let answer =
    //   arrayMin >= this.input.ideal ? this.input.ideal % step !== 0 ?
    //   this.input.ideal : this.input.ideal - step : arrayMin;
    // answer = (Math.floor(answer / step)) * step;
    const answer =
      arrayMin > this.input.ideal ? this.input.ideal - 1 : arrayMin - 1;
    return answer;
  }

  calculateMaxValue(): number {
    const arrayMax = Math.max(...this.input.data);
    // const step = this.calculateStepValue();
    // let answer =
    //   arrayMax <= this.input.ideal ? this.input.ideal % step !== 0 ?
    //   this.input.ideal : this.input.ideal + step : arrayMax;
    // answer = (Math.ceil(answer / step)) * step;
    const answer =
      arrayMax < this.input.ideal ? this.input.ideal + 1 : arrayMax + 1;
    return answer;
  }

  calculateStepValue(): number {
    const arrayMin = Math.min(...this.input.data);
    const arrayMax = Math.max(...this.input.data);
    if (arrayMin > this.input.ideal) {
      return arrayMax - this.input.ideal <= 2
        ? 1
        : arrayMax - this.input.ideal <= 4
        ? 2
        : arrayMax - this.input.ideal <= 6
        ? 3
        : arrayMax - this.input.ideal <= 10
        ? 5
        : arrayMax - this.input.ideal <= 20
        ? 10
        : arrayMax - this.input.ideal <= 30
        ? 15
        : 20;
    } else if (arrayMax < this.input.ideal) {
      return this.input.ideal - arrayMin <= 2
        ? 1
        : this.input.ideal - arrayMin <= 4
        ? 2
        : this.input.ideal - arrayMin <= 6
        ? 3
        : this.input.ideal - arrayMin <= 10
        ? 5
        : this.input.ideal - arrayMin <= 20
        ? 10
        : this.input.ideal - arrayMin <= 30
        ? 15
        : 20;
    } else {
      return arrayMax - arrayMin <= 2
        ? 1
        : arrayMax - arrayMin <= 4
        ? 2
        : arrayMax - arrayMin <= 6
        ? 3
        : arrayMax - arrayMin <= 10
        ? 5
        : arrayMax - arrayMin <= 20
        ? 10
        : arrayMax - arrayMin <= 30
        ? 15
        : 20;
    }
  }
}
